import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FuncionalidadService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/funcionalidad';
  private basePathUrl = '/url';
  private basePathEmpresa = '/empresa';

  constructor(private http: HttpClient) {}

  cargarFuncionalidadesPorTipoUsuario(
    tipoUsuarioId: number,
    token?: string
  ): Observable<any> {
    let headers;
    if(token){
      headers = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
    }
    return this.http.get<any>(
      `${this.apiUrl}${this.baseUrl}/${tipoUsuarioId}`,
      headers
    );
  }

  cargarFuncionalidadesPorTipoUsuarioEmpresa(
    tipoUsuarioId: number,
    token?: string
  ): Observable<any> {
    console.log('[cargarFuncionalidadesPorTipoUsuarioEmpresa]');
    console.log('tipoUsuarioId:', tipoUsuarioId);
    console.log('token recibido:', token);

    let headers;
    if (token) {
      headers = {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      };
      console.log('Headers con token:', headers);
    } else {
      console.log('Sin token - usando cookie automática');
    }

    const url = `${this.apiUrl}${this.baseUrl}${this.basePathEmpresa}/${tipoUsuarioId}`;
    console.log('URL completa:', url);
    return this.http.get<any>(url, headers);
  }

  cargarFuncionalidadesPorTipoUsuarioYCategoria(
    tipoUsuarioId: number,
    categoria: string
  ): Observable<[]> {
    return this.http.get<any>(`${this.apiUrl}${this.baseUrl}`, {
      params: {
        tipoUsuario: tipoUsuarioId,
        categoria: categoria,
      },
    });
  }

  obtenerUrlFuncionalidadesPorTipoUsuarioYCategoria(tipoUsuarioId: number, categorias: string[]): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}${this.baseUrl}${this.basePathUrl}`, {
      params: { tipoUsuario: tipoUsuarioId, categorias: categorias },
    });
  }

}
